module.exports = __webpack_public_path__ + "static/media/amend.007264f1.svg";